import { useEffect } from 'react';
import { navigate } from "@reach/router"

const SlateAppDashboardPage = () => {
  useEffect(() => {
    navigate('/');
  }, []);
  return null;
};

export default SlateAppDashboardPage;